__turbopack_context__.v({
  "body": "CourseSection-module__ZyOMHq__body",
  "bodyWithFooter": "CourseSection-module__ZyOMHq__bodyWithFooter",
  "header": "CourseSection-module__ZyOMHq__header",
  "optionCard": "CourseSection-module__ZyOMHq__optionCard",
  "optionCardDescription": "CourseSection-module__ZyOMHq__optionCardDescription",
  "section": "CourseSection-module__ZyOMHq__section",
  "splitAside": "CourseSection-module__ZyOMHq__splitAside",
  "splitBody": "CourseSection-module__ZyOMHq__splitBody",
  "splitMain": "CourseSection-module__ZyOMHq__splitMain",
});
